import templateOnly from '@ember/component/template-only';

export interface SpinnerSignature {
  Args: object;
}

const SpinnerComponent = templateOnly<SpinnerSignature>();

export default SpinnerComponent;
